import { IContractStatusSelectorProps } from "./ContractStatusSelector.tsx";
import { put } from "@common/api/apiShared.ts";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useEffect, useMemo, useState } from "react";
import { DotLegalSelectOption } from "@common/components/dotLegalMultiSelect/DotLegalMultiSelect.types.ts";
import { ContractStatus } from "../../Contracts.types.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useContractStatusOptions() {
    const { translateContractStatusEnum } = useTranslation();
    const options = useMemo(
        (): Array<DotLegalSelectOption> => [
            { id: "1", name: translateContractStatusEnum(ContractStatus.Draft.toString()) },
            { id: "2", name: translateContractStatusEnum(ContractStatus.Approved.toString()) },
            { id: "3", name: translateContractStatusEnum(ContractStatus.Archived.toString()) },
        ],
        [translateContractStatusEnum]
    );

    return { options };
}

export function useContractStatusSelector(props: IContractStatusSelectorProps) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    const [selectedStatus, setSelectedStatus] = useState<DotLegalSelectOption>();
    const { options } = useContractStatusOptions();

    useEffect(() => {
        if (props.currentStatus) {
            const status = options.find((x) => x.id === props.currentStatus!.toString());
            setSelectedStatus(status);
        }
    }, [options, props.currentStatus]);

    const updateMutation = useDotLegalMutation(update);
    const onUpdate = (status: string) => {
        updateMutation.mutateAsync(status, {
            onSuccess: (resp: any) => {
                snackbar.show(translateString("statusUpdated"), "success");
                props.refetch();
            },
        });
    };

    function update(status: string) {
        const selectedOption = options.find((x) => x.id === status);
        setSelectedStatus(selectedOption!);
        return put<{}>(`/contracts/${props.contractId}/status/`, Number(selectedOption!.id));
    }

    return { options, selectedStatus, setSelectedStatus, onUpdate };
}
